import { areasAll } from '@studyportals/static-domain-data/areas/areas';
import { areaGetPath } from '@studyportals/static-domain-data/areas/area-get-path';
import { Area } from '@/router/fragments/fragment-items/Area';
import { AreaFilterOptionInformation } from '@studyportals/search-filters';

class AreaPresenter {
	public allWithPaths(): Area[] {
		const areas: Area[] = [];

		areasAll.forEach((area) => {
			const pathWithCountry = areaGetPath(area.id);
			const path = pathWithCountry?.split('/')[1];
			if (path == null) {
				return;
			}
			areas.push(new Area(area.id, path));
		});

		return areas;
	}

	public allOptions(): AreaFilterOptionInformation[] {
		return areasAll.map((c) => new AreaFilterOptionInformation(c.name, c.id, '', '', c.countryId));
	}

	public getAreaNameById(areaId: string): string | null {
		const foundArea = areasAll.find((area) => area.id === areaId);
		return foundArea ? foundArea.name : null;
	}

	public getAreaSlugById(areaId: string): string | null {
		return areaGetPath(areaId) || null;
	}
}

const areaPresenterInstance = new AreaPresenter();

export { areaPresenterInstance as AreaPresenter };
